import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Shield } from 'lucide-react';
import { Button } from '../components/ui/button';
import CompanyComplianceSettingsPanel from '../components/vendors/CompanyComplianceSettingsPanel';
import CompanyComplianceSummaryPanel from '../components/vendors/CompanyComplianceSummaryPanel';
import { useSubscription } from '../contexts/SubscriptionContext';

const VendorComplianceSettingsPage: React.FC = () => {
  const { hasFeature } = useSubscription();
  const hasVendorCompliance = hasFeature('hasVendorCompliance');

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between gap-4">
        <div className="flex items-center space-x-4">
          <Button variant="outline" asChild>
            <Link to="/admin" className="flex items-center space-x-2">
              <ArrowLeft className="h-4 w-4" />
              <span>System Settings</span>
            </Link>
          </Button>
          <div>
            <div className="flex items-center gap-2">
              <Shield className="h-6 w-6 text-gray-900 dark:text-gray-100" />
              <h1 className="text-2xl font-semibold text-gray-900 dark:text-gray-100">
                Vendor Compliance Requirements
              </h1>
            </div>
            <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
              Configure required insurance, coverage minimums, and document review rules for all vendors.
            </p>
          </div>
        </div>
      </div>

      {!hasVendorCompliance ? (
        <div className="max-w-3xl card">
          <div className="card-body space-y-3">
            <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100">Enterprise feature</h2>
            <p className="text-sm text-gray-600 dark:text-gray-400">
              Vendor compliance requirements are available on the Enterprise plan. Upgrade to configure
              required COI types, minimum limits, W-9 review, and vendor attestations.
            </p>
            <Button asChild>
              <Link to="/settings/subscription">View subscription plans</Link>
            </Button>
          </div>
        </div>
      ) : (
        <>
          <CompanyComplianceSummaryPanel />
          <CompanyComplianceSettingsPanel standalone />
        </>
      )}
    </div>
  );
};

export default VendorComplianceSettingsPage;
